import { useQuery } from "react-query";
import { internalApi } from "@/react/helpers/urlHelpers";
import type { Space } from "@/react/types/Space";
import { reactQueryGet } from "@circle-react/helpers/backendRequestHelpers";

export const useFetchSpace = ({
  id,
  options = {},
}: {
  id: string;
  options?: any;
}) =>
  useQuery(
    ["space", id],
    () => reactQueryGet<Space>(internalApi.spaces.show({ id })),
    {
      enabled: !!id,
      ...options,
    },
  );
